import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { fetchNpsCsatConfig, fetchNpsCsatSummary, removeNpsCsatConfig } from 'redux/actions/analytics';
import { AnalyticsPageType } from 'redux/schemas/app/analytics';
import { getNpsCsatConfiguration, getQuestionSets, isNpsCsatConfigurable } from 'redux/selectors/analytics';
import { useAppDispatch } from 'redux/store';
import { AngularContext } from 'react-app';

import ConfigureLink from './configure-link';
import NpsCsatConfigurationModal from './nps-csat-configuration-modal';

type NpsCsatConfigurationWrapperProps = {
  questionSetId?: number,
  analyticsPageType?: AnalyticsPageType,
};

const NpsCsatConfigurationWrapper = ({
  questionSetId,
  analyticsPageType = AnalyticsPageType.COURSE_ANALYTICS,
}: NpsCsatConfigurationWrapperProps) => {
  const { injectServices } = useContext(AngularContext);
  const [$state] = injectServices(['$state']);

  const isConfigurable = useSelector(isNpsCsatConfigurable);
  const npsCsatConfig = useSelector(getNpsCsatConfiguration);
  const npsCsatConfigKey = useSelector((state) => state.app.analytics.npsCsatConfigKey);
  const institutionId = useSelector(state => state.app.currentInstitutionId);
  const catalogId = useSelector((state) => state.app.currentCatalogId);
  const questionSets = useSelector(state => getQuestionSets(state, analyticsPageType));
  const dispatch = useAppDispatch();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const isSelectedSurvey = Boolean(
    questionSetId && questionSets?.surveys?.some((survey) => survey.id === questionSetId),
  );

  useEffect(() => {
    if (
      isSelectedSurvey
      && npsCsatConfigKey?.institutionId === institutionId
      && npsCsatConfigKey?.catalogId === catalogId
      && npsCsatConfigKey?.questionSetId === questionSetId
      && npsCsatConfig?.configured
    ) {
      dispatch(fetchNpsCsatSummary({
        institutionId,
        catalogId,
        questionSetId,
        type: analyticsPageType,
        cohorts: $state.params?.cohorts,
      }));
    }
  }, [catalogId, questionSetId, dispatch, institutionId, analyticsPageType, npsCsatConfig, npsCsatConfigKey, $state.params?.cohorts, isSelectedSurvey]);

  useEffect(() => {
    if (questionSetId && institutionId && catalogId && isSelectedSurvey) {
      dispatch(fetchNpsCsatConfig({
        institutionId,
        catalogId,
        questionSetId,
      }));
    } else {
      dispatch(removeNpsCsatConfig());
    }
  }, [catalogId, questionSetId, dispatch, institutionId, isSelectedSurvey]);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  if (!isSelectedSurvey) {
    return null;
  }
  return (
    <div>
      {isConfigurable && <ConfigureLink onClick={openModal} />}
      {isModalOpen && <NpsCsatConfigurationModal onClose={closeModal} />}
    </div>
  );
};

export default NpsCsatConfigurationWrapper;
